import React from 'react';
import womenSmile from '../../assets/women-smile.png';

import { ButtonGrow, Container, ContaineText } from './style';

function Grow() {
  const handleMenuClick = React.useCallback(() => {
    const section = document.getElementById('7');
    const offset = 94;
    const elementPosition =
      section.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }, []);

  return (
    <Container>
      <ContaineText>
        <p>
          Transformando <br />
          <strong>você</strong>, para você <br />
          transformar o <strong>seu </strong>
          <br />
          <strong> negócio</strong>
        </p>

        <ButtonGrow onClick={() => handleMenuClick()}>
          Iniciar minha jornada
        </ButtonGrow>
      </ContaineText>
      <img src={womenSmile} alt="crescimento" />
    </Container>
  );
}

export default Grow;
